import { render, staticRenderFns } from "./BPMNRemoteService.vue?vue&type=template&id=6d60564c&"
import script from "./BPMNRemoteService.vue?vue&type=script&lang=js&"
export * from "./BPMNRemoteService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports